import commonRequest from "./common";

export default {
  methods: {
    guestRequest(options, uri, guestCredentials, onSuccess, onError) {
      if (!guestCredentials) {
        console.error("No credentials provided");
        return;
      }

      const headers = {
        "X-Ticket-Id": guestCredentials.ticketId,
      };

      const baseUrl = process.env.VUE_APP_API;
      commonRequest(baseUrl, options, uri, onSuccess, onError, headers);
    },
  },
};
